import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/Login';

// file download
import DPFileDownLoad from '@/components/DPEBB/Administrator/FileDownLoad'

//import DPFileDownLoad from '@/components/DPEBB/Administrator/FileDownLoad'

//faq
import DpebbFaq from '@/Common/Default/Faq';
//contact us
import DpebbContactus from '@/Common/Default/ContactUs';
//Dental
import DentalHome from '../components/Dental/Home';
//SuperUser
import SuperUserDentalPriorApproval from '../Dental/SuperUser/PriorApproval';
import SuperUserDentalAddClaim from '../Dental/SuperUser/AddClaim'
import SuperUserDentalVoidClaim from '../Dental/SuperUser/VoidClaim'
import SuperUserDentalPatientHistory from '../Dental/SuperUser/PatientHistory'
import SuperUserDentalPatientEligibility from '../Dental/SuperUser/PatientEligibility';
import SuperUserDentalPatientSummary from '../Dental/SuperUser/PatientSummary';
import SuperUserDentalPaylist from '@/Dental/SuperUser/Paylist';
import SuperUserDentalManagePatientNotes from '../Dental/SuperUser/ManagePatientNotes';
import SuperUserDentalPatientCoverage from '../Dental/SuperUser/PatientCoverage';
import SuperUserDentalViewBulletins from '../Dental/SuperUser/ViewBulletins';
//SystemAdmin
//Assessor
import AssessorDentalPriorApproval from '../Dental/Assessor/PriorApproval';
import AssessorUserDentalAddClaim from '../Dental/Assessor/AddClaim'
import AssessorUserDentalVoidClaim from '../Dental/Assessor/VoidClaim'
import AssessorDentalPatientHistory from '../Dental/Assessor/PatientHistory'
import AssessorDentalPatientEligibility from '../Dental/Assessor/PatientEligibility'
import AssessorDentalPatientSummary from '../Dental/Assessor/PatientSummary';
import AssessorDentalPaylist from '@/Dental/Assessor/Paylist';
import AssessorDentalManagePatientNotes from '../Dental/Assessor/ManagePatientNotes';
import AssessorDentalPatientCoverage from '../Dental/Assessor/PatientCoverage';
import AssessorDentalViewBulletins from '../Dental/Assessor/ViewBulletins';
//LeadAssessor
import LeadAssessorDentalPriorApproval from '../Dental/LeadAssessor/PriorApproval';
import LeadAssessorUserDentalAddClaim from '../Dental/LeadAssessor/AddClaim'
import LeadAssessorUserDentalVoidClaim from '../Dental/LeadAssessor/VoidClaim'
import LeadAssessorDentalPatientHistory from '../Dental/LeadAssessor/PatientHistory'
import LeadAssessorDentalPatientEligibility from '../Dental/LeadAssessor/PatientEligibility'
import LeadAssessorDentalPatientSummary from '../Dental/LeadAssessor/PatientSummary';
import LeadAssessorDentalPaylist from '@/Dental/LeadAssessor/Paylist';
import LeadAssessorDentalManagePatientNotes from '../Dental/LeadAssessor/ManagePatientNotes';
import LeadAssessorDentalPatientCoverage from '../Dental/LeadAssessor/PatientCoverage';
import LeadAssessorDentalViewBulletins from '../Dental/LeadAssessor/ViewBulletins';
//Policy
import PolicyDentalPatientHistory from '../Dental/Policy/PatientHistory'
import PolicyDentalPatientEligibility from '../Dental/Policy/PatientEligibility'
import PolicyDentalPatientSummary from '../Dental/Policy/PatientSummary';
import DPEBBPolicyDentalViewPatientNotes from '../Dental/Policy/ViewPatientNotes';
import PolicyDentalPatientCoverage from '../Dental/Policy/PatientCoverage';
import PolicyDentalViewBulletins from '../Dental/Policy/ViewBulletins';
//Finance
import FinanceDentalPaylist from '@/Dental/Finance/Paylist';
import FinanceDentalViewBulletins from '../Dental/Finance/ViewBulletins';
//Labs
import LabsDentalAddClaim from '../Dental/Labs/AddClaim'
import LabsDentalVoidClaim from '../Dental/Labs/VoidClaim'
import LabsDentalViewBulletins from '../Dental/Labs/ViewBulletins';
import LabsDentalPatientHistory from '../Dental/Labs/PatientHistory';
//Provider
import ProviderDentalPriorApproval from '../Dental/Provider/PriorApproval';
import ProviderDentalAddClaim from '../Dental/Provider/AddClaim'
import ProviderDentalVoidClaim from '../Dental/Provider/VoidClaim'
import ProviderDentalPatientHistory from '../Dental/Provider/PatientHistory'
import ProviderDentalPatientEligibility from '../Dental/Provider/PatientEligibility'
import ProviderDentalPatientSummary from '../Dental/Provider/PatientSummary';
import ProviderDentalPaylist from '@/Dental/Provider/Paylist';
import ProviderDentalViewBulletins from '../Dental/Provider/ViewBulletins';
  

//Medical
import MedicalHome from '../components/MedicalSupply/Home';
//SuperUser
import SuperUserMedicalSupplyPriorApproval from '../MedicalSupply/SuperUser/PriorApproval';
import SuperUserMedicalSupplyAddClaim from '../MedicalSupply/SuperUser/AddClaim'
import SuperUserMedicalSupplyVoidClaim from '../MedicalSupply/SuperUser/VoidClaim'
import SuperUserMedicalSupplyPatientHistory from '../MedicalSupply/SuperUser/PatientHistory'
import SuperUserMedicalSupplyPatientEligibility from '../MedicalSupply/SuperUser/PatientEligibility'
import SuperUserMedicalSupplyPatientSummary from '../MedicalSupply/SuperUser/PatientSummary';
import SuperUserMedicalSupplyPaylist from '@/MedicalSupply/SuperUser/Paylist';
import SuperUserMedicalSupplyManagePatientNotes from '../MedicalSupply/SuperUser/ManagePatientNotes';
import SuperUserMedicalSupplyPatientCoverage from '../MedicalSupply/SuperUser/PatientCoverage';
import SuperUserMedicalSupplyViewBulletins from '../MedicalSupply/SuperUser/ViewBulletins';
//SystemAdmin
//Assessor  
import AssessorMedicalSupplyPriorApproval from '../MedicalSupply/Assessor/PriorApproval';
import AssessorUserMedicalSupplyAddClaim from '../MedicalSupply/Assessor/AddClaim'
import AssessorUserMedicalSupplyVoidClaim from '../MedicalSupply/Assessor/VoidClaim'
import AssessorMedicalSupplyPatientHistory from '../MedicalSupply/Assessor/PatientHistory'
import AssessorMedicalSupplyPatientEligibility from '../MedicalSupply/Assessor/PatientEligibility'
import AssessorMedicalSupplyPatientSummary from '../MedicalSupply/Assessor/PatientSummary';
import AssessorMedicalSupplyPaylist from '@/MedicalSupply/Assessor/Paylist';
import AssessorMedicalSupplyManagePatientNotes from '../MedicalSupply/Assessor/ManagePatientNotes';
import AssessorMedicalSupplyPatientCoverage from '../MedicalSupply/Assessor/PatientCoverage';
import AssessorMedicalSupplyViewBulletins from '../MedicalSupply/Assessor/ViewBulletins';
//LeadAssessor
import LeadAssessorMedicalSupplyPriorApproval from '../MedicalSupply/LeadAssessor/PriorApproval';
import LeadAssessorUserMedicalSupplyAddClaim from '../MedicalSupply/LeadAssessor/AddClaim'
import LeadAssessorUserMedicalSupplyVoidClaim from '../MedicalSupply/LeadAssessor/VoidClaim'
import LeadAssessorMedicalSupplyPatientHistory from '../MedicalSupply/LeadAssessor/PatientHistory'
import LeadAssessorMedicalSupplyPatientEligibility from '../MedicalSupply/LeadAssessor/PatientEligibility'
import LeadAssessorMedicalSupplyPatientSummary from '../MedicalSupply/LeadAssessor/PatientSummary';
import LeadAssessorMedicalSupplyPaylist from '@/MedicalSupply/LeadAssessor/Paylist';
import LeadAssessorMedicalSupplyManagePatientNotes from '../MedicalSupply/LeadAssessor/ManagePatientNotes';
import LeadAssessorMedicalSupplyPatientCoverage from '../MedicalSupply/LeadAssessor/PatientCoverage';
import LeadAssessorMedicalSupplyViewBulletins from '../MedicalSupply/LeadAssessor/ViewBulletins';
//Policy
import PolicyMedicalSupplyPatientHistory from '../MedicalSupply/Policy/PatientHistory'
import PolicyMedicalSupplyPatientEligibility from '../MedicalSupply/Policy/PatientEligibility'
import PolicyMedicalSupplyPatientSummary from '../MedicalSupply/Policy/PatientSummary';
import DPEBBPolicyMedicalSupplyViewPatientNotes from '../MedicalSupply/Policy/ViewPatientNotes';
import PolicyMedicalSupplyPatientCoverage from '../MedicalSupply/Policy/PatientCoverage';
import PolicyMedicalSupplyViewBulletins from '../MedicalSupply/Policy/ViewBulletins';
//Finance
import FinanceMedicalSupplyPaylist from '@/MedicalSupply/Finance/Paylist';
import FinanceMedicalSupplyViewBulletins from '../MedicalSupply/Finance/ViewBulletins';
//Labs
import LabsMedicalSupplyAddClaim from '../MedicalSupply/Labs/AddClaim'
import LabsMedicalSupplyVoidClaim from '../MedicalSupply/Labs/VoidClaim'
import LabsMedicalSupplyViewBulletins from '../MedicalSupply/Labs/ViewBulletins';
//Provider
import ProviderMedicalSupplyPriorApproval from '../MedicalSupply/Provider/PriorApproval';
import ProviderMedicalSupplyAddClaim from '../MedicalSupply/Provider/AddClaim'
import ProviderMedicalSupplyVoidClaim from '../MedicalSupply/Provider/VoidClaim'
import ProviderMedicalSupplyPatientHistory from '../MedicalSupply/Provider/PatientHistory'
import ProviderMedicalSupplyPatientEligibility from '../MedicalSupply/Provider/PatientEligibility'
import ProviderMedicalSupplyPatientSummary from '../MedicalSupply/Provider/PatientSummary';
import ProviderMedicalSupplyPaylist from '@/MedicalSupply/Provider/Paylist';
import ProviderMedicalSupplyViewBulletins from '../MedicalSupply/Provider/ViewBulletins';

//Optical
import OpticalHome from '../components/Optical/Home';
//SuperUser
import SuperUserOpticalPriorApproval from '../Optical/SuperUser/PriorApproval';
import SuperUserOpticalAddClaim from '../Optical/SuperUser/AddClaim'
import SuperUserOpticalVoidClaim from '../Optical/SuperUser/VoidClaim'
import SuperUserOpticalPatientHistory from '../Optical/SuperUser/PatientHistory'
import SuperUserOpticalPatientEligibility from '../Optical/SuperUser/PatientEligibility'
import SuperUserOpticalPatientSummary from '../Optical/SuperUser/PatientSummary';
import SuperUserOpticalPaylist from '@/Optical/SuperUser/Paylist';
import SuperUserOpticalManagePatientNotes from '../Optical/SuperUser/ManagePatientNotes';
import SuperUserOpticalPatientCoverage from '../Optical/SuperUser/PatientCoverage';
import SuperUserOpticalViewBulletins from '../Optical/SuperUser/ViewBulletins';
//SystemAdmin
//Assessor
import AssessorOpticalPriorApproval from '../Optical/Assessor/PriorApproval';
import AssessorUserOpticalAddClaim from '../Optical/Assessor/AddClaim'
import AssessorUserOpticalVoidClaim from '../Optical/Assessor/VoidClaim'
import AssessorOpticalPatientHistory from '../Optical/Assessor/PatientHistory'
import AssessorOpticalPatientEligibility from '../Optical/Assessor/PatientEligibility'
import AssessorOpticalPatientSummary from '../Optical/Assessor/PatientSummary';
import AssessorOpticalPaylist from '@/Optical/Assessor/Paylist';
import AssessorOpticalManagePatientNotes from '../Optical/Assessor/ManagePatientNotes';
import AssessorOpticalPatientCoverage from '../Optical/Assessor/PatientCoverage';
import AssessorOpticalViewBulletins from '../Optical/Assessor/ViewBulletins';
//LeadAssessor
import LeadAssessorOpticalPriorApproval from '../Optical/LeadAssessor/PriorApproval';
import LeadAssessorUserOpticalAddClaim from '../Optical/LeadAssessor/AddClaim'
import LeadAssessorUserOpticalVoidClaim from '../Optical/LeadAssessor/VoidClaim'
import LeadAssessorOpticalPatientHistory from '../Optical/LeadAssessor/PatientHistory'
import LeadAssessorOpticalPatientEligibility from '../Optical/LeadAssessor/PatientEligibility'
import LeadAssessorOpticalPatientSummary from '../Optical/LeadAssessor/PatientSummary';
import LeadAssessorOpticalPaylist from '@/Optical/LeadAssessor/Paylist';
import LeadAssessorOpticalManagePatientNotes from '../Optical/LeadAssessor/ManagePatientNotes';
import LeadAssessorOpticalPatientCoverage from '../Optical/LeadAssessor/PatientCoverage';
import LeadAssessorOpticalViewBulletins from '../Optical/LeadAssessor/ViewBulletins';
//Policy
import PolicyOpticalPatientHistory from '../Optical/Policy/PatientHistory'
import PolicyOpticalPatientEligibility from '../Optical/Policy/PatientEligibility'
import PolicyOpticalPatientSummary from '../Optical/Policy/PatientSummary';
import DPEBBPolicyOpticalViewPatientNotes from '../Optical/Policy/ViewPatientNotes';
import PolicyOpticalPatientCoverage from '../Optical/Policy/PatientCoverage';
import PolicyOpticalViewBulletins from '../Optical/Policy/ViewBulletins';
//Finance
import FinanceOpticalPaylist from '@/Optical/Finance/Paylist';
import FinanceOpticalViewBulletins from '../Optical/Finance/ViewBulletins';
//Labs
import LabsOpticalAddClaim from '../Optical/Labs/AddClaim'
import LabsOpticalVoidClaim from '../Optical/Labs/VoidClaim'
import LabsOpticalViewBulletins from '../Optical/Labs/ViewBulletins';
//Provider
import ProviderOpticalPriorApproval from '../Optical/Provider/PriorApproval';
import ProviderOpticalAddClaim from '../Optical/Provider/AddClaim'
import ProviderOpticalVoidClaim from '../Optical/Provider/VoidClaim'
import ProviderOpticalPatientHistory from '../Optical/Provider/PatientHistory'
import ProviderOpticalPatientEligibility from '../Optical/Provider/PatientEligibility'
import ProviderOpticalPatientSummary from '../Optical/Provider/PatientSummary';
import ProviderOpticalPaylist from '@/Optical/Provider/Paylist';
import ProviderOpticalViewBulletins from '../Optical/Provider/ViewBulletins';
//Hearing
import HearingHome from '../components/Hearing/Home';
//SuperUser
import SuperUserHearingPriorApproval from '../Hearing/SuperUser/PriorApproval';
import SuperUserHearingAddClaim from '../Hearing/SuperUser/AddClaim'
import SuperUserHearingVoidClaim from '../Hearing/SuperUser/VoidClaim'
import SuperUserHearingPatientHistory from '../Hearing/SuperUser/PatientHistory'
import SuperUserHearingPatientEligibility from '../Hearing/SuperUser/PatientEligibility'
import SuperUserHearingPatientSummary from '../Hearing/SuperUser/PatientSummary';
import SuperUserHearingPaylist from '@/Hearing/SuperUser/Paylist';
import SuperUserHearingManagePatientNotes from '../Hearing/SuperUser/ManagePatientNotes';
import SuperUserHearingPatientCoverage from '../Hearing/SuperUser/PatientCoverage';
import SuperUserHearingViewBulletins from '../Hearing/SuperUser/ViewBulletins';
//SystemAdmin
//Assessor
import AssessorHearingPriorApproval from '../Hearing/Assessor/PriorApproval';
import AssessorUserHearingAddClaim from '../Hearing/Assessor/AddClaim'
import AssessorUserHearingVoidClaim from '../Hearing/Assessor/VoidClaim'
import AssessorHearingPatientHistory from '../Hearing/Assessor/PatientHistory'
import AssessorHearingPatientEligibility from '../Hearing/Assessor/PatientEligibility'
import AssessorHearingPatientSummary from '../Hearing/Assessor/PatientSummary';
import AssessorHearingPaylist from '@/Hearing/Assessor/Paylist';
import AssessorHearingManagePatientNotes from '../Hearing/Assessor/ManagePatientNotes';
import AssessorHearingPatientCoverage from '../Hearing/Assessor/PatientCoverage';
import AssessorHearingViewBulletins from '../Hearing/Assessor/ViewBulletins';
//LeadAssessor
import LeadAssessorHearingPriorApproval from '../Hearing/LeadAssessor/PriorApproval';
import LeadAssessorUserHearingAddClaim from '../Hearing/LeadAssessor/AddClaim'
import LeadAssessorUserHearingVoidClaim from '../Hearing/LeadAssessor/VoidClaim'
import LeadAssessorHearingPatientHistory from '../Hearing/LeadAssessor/PatientHistory'
import LeadAssessorHearingPatientEligibility from '../Hearing/LeadAssessor/PatientEligibility'
import LeadAssessorHearingPatientSummary from '../Hearing/LeadAssessor/PatientSummary';
import LeadAssessorHearingPaylist from '@/Hearing/LeadAssessor/Paylist';
import LeadAssessorHearingManagePatientNotes from '../Hearing/LeadAssessor/ManagePatientNotes';
import LeadAssessorHearingPatientCoverage from '../Hearing/LeadAssessor/PatientCoverage';
import LeadAssessorHearingViewBulletins from '../Hearing/LeadAssessor/ViewBulletins';
//Policy
import PolicyHearingPatientHistory from '../Hearing/Policy/PatientHistory'
import PolicyHearingPatientEligibility from '../Hearing/Policy/PatientEligibility'
import PolicyHearingPatientSummary from '../Hearing/Policy/PatientSummary';
import DPEBBPolicyHearingViewPatientNotes from '../Hearing/Policy/ViewPatientNotes';
import PolicyHearingPatientCoverage from '../Hearing/Policy/PatientCoverage';
import PolicyHearingViewBulletins from '../Hearing/Policy/ViewBulletins';
//Finance
import FinanceHearingPaylist from '@/Hearing/Finance/Paylist';
import FinanceHearingViewBulletins from '../Hearing/Finance/ViewBulletins';
//Labs
import LabsHearingAddClaim from '../Hearing/Labs/AddClaim'
import LabsHearingVoidClaim from '../Hearing/Labs/VoidClaim'
import LabsHearingViewBulletins from '../Hearing/Labs/ViewBulletins';
//Provider
import ProviderHearingPriorApproval from '../Hearing/Provider/PriorApproval';
import ProviderHearingAddClaim from '../Hearing/Provider/AddClaim'
import ProviderHearingVoidClaim from '../Hearing/Provider/VoidClaim'
import ProviderHearingPatientHistory from '../Hearing/Provider/PatientHistory'
import ProviderHearingPatientEligibility from '../Hearing/Provider/PatientEligibility'
import ProviderHearingPatientSummary from '../Hearing/Provider/PatientSummary';
import ProviderHearingPaylist from '@/Hearing/Provider/Paylist';
import ProviderHearingViewBulletins from '../Hearing/Provider/ViewBulletins';

//Podiatry
import PodiatryHome from '../components/Podiatry/Home';
//SuperUser
import SuperUserPodiatryPriorApproval from '../Podiatry/SuperUser/PriorApproval';
import SuperUserPodiatryAddClaim from '../Podiatry/SuperUser/AddClaim'
import SuperUserPodiatryVoidClaim from '../Podiatry/SuperUser/VoidClaim'
import SuperUserPodiatryPatientHistory from '../Podiatry/SuperUser/PatientHistory'
import SuperUserPodiatryPatientEligibility from '../Podiatry/SuperUser/PatientEligibility'
import SuperUserPodiatryPatientSummary from '../Podiatry/SuperUser/PatientSummary';
import SuperUserPodiatryPaylist from '@/Podiatry/SuperUser/Paylist';
import SuperUserPodiatryManagePatientNotes from '../Podiatry/SuperUser/ManagePatientNotes';
import SuperUserPodiatryPatientCoverage from '../Podiatry/SuperUser/PatientCoverage';
import SuperUserPodiatryViewBulletins from '../Podiatry/SuperUser/ViewBulletins';
//SystemAdmin
//Assessor
import AssessorPodiatryPriorApproval from '../Podiatry/Assessor/PriorApproval';
import AssessorUserPodiatryAddClaim from '../Podiatry/Assessor/AddClaim'
import AssessorUserPodiatryVoidClaim from '../Podiatry/Assessor/VoidClaim'
import AssessorPodiatryPatientHistory from '../Podiatry/Assessor/PatientHistory'
import AssessorPodiatryPatientEligibility from '../Podiatry/Assessor/PatientEligibility'
import AssessorPodiatryPatientSummary from '../Podiatry/Assessor/PatientSummary';
import AssessorPodiatryPaylist from '@/Podiatry/Assessor/Paylist';
import AssessorPodiatryManagePatientNotes from '../Podiatry/Assessor/ManagePatientNotes';
import AssessorPodiatryPatientCoverage from '../Podiatry/Assessor/PatientCoverage';
import AssessorPodiatryViewBulletins from '../Podiatry/Assessor/ViewBulletins';
//LeadAssessor
import LeadAssessorPodiatryPriorApproval from '../Podiatry/LeadAssessor/PriorApproval';
import LeadAssessorUserPodiatryAddClaim from '../Podiatry/LeadAssessor/AddClaim'
import LeadAssessorUserPodiatryVoidClaim from '../Podiatry/LeadAssessor/VoidClaim'
import LeadAssessorPodiatryPatientHistory from '../Podiatry/LeadAssessor/PatientHistory'
import LeadAssessorPodiatryPatientEligibility from '../Podiatry/LeadAssessor/PatientEligibility'
import LeadAssessorPodiatryPatientSummary from '../Podiatry/LeadAssessor/PatientSummary';
import LeadAssessorPodiatryPaylist from '@/Podiatry/LeadAssessor/Paylist';
import LeadAssessorPodiatryManagePatientNotes from '../Podiatry/LeadAssessor/ManagePatientNotes';
import LeadAssessorPodiatryPatientCoverage from '../Podiatry/LeadAssessor/PatientCoverage';
import LeadAssessorPodiatryViewBulletins from '../Podiatry/LeadAssessor/ViewBulletins';
//Policy
import PolicyPodiatryPatientHistory from '../Podiatry/Policy/PatientHistory'
import PolicyPodiatryPatientEligibility from '../Podiatry/Policy/PatientEligibility'
import PolicyPodiatryPatientSummary from '../Podiatry/Policy/PatientSummary';
import DPEBBPolicyPodiatryViewPatientNotes from '../Podiatry/Policy/ViewPatientNotes';
import PolicyPodiatryPatientCoverage from '../Podiatry/Policy/PatientCoverage';
import PolicyPodiatryViewBulletins from '../Podiatry/Policy/ViewBulletins';
//Finance
import FinancePodiatryPaylist from '@/Podiatry/Finance/Paylist';
import FinancePodiatryViewBulletins from '../Podiatry/Finance/ViewBulletins';
//Labs
import LabsPodiatryAddClaim from '../Podiatry/Labs/AddClaim'
import LabsPodiatryVoidClaim from '../Podiatry/Labs/VoidClaim'
import LabsPodiatryViewBulletins from '../Podiatry/Labs/ViewBulletins';
//Provider
import ProviderPodiatryPriorApproval from '../Podiatry/Provider/PriorApproval';
import ProviderPodiatryAddClaim from '../Podiatry/Provider/AddClaim'
import ProviderPodiatryVoidClaim from '../Podiatry/Provider/VoidClaim'
import ProviderPodiatryPatientHistory from '../Podiatry/Provider/PatientHistory'
import ProviderPodiatryPatientEligibility from '../Podiatry/Provider/PatientEligibility'
import ProviderPodiatryPatientSummary from '../Podiatry/Provider/PatientSummary';
import ProviderPodiatryPaylist from '@/Podiatry/Provider/Paylist';
import ProviderPodiatryViewBulletins from '../Podiatry/Provider/ViewBulletins';

//DPEBB
//import DPEBBGreenScreenHome from '@/components/DPEBB/DP-GreenScreensHome';
import DPEBBHome from '../components/DPEBB/Home';
import DPEBBMainHome from '../components/DPEBB/MainHome';
import UpdatePasswordHome from '@/components/DPEBB/Administrator/UserUpdatePassowrd' ;
import ServiceType from '../components/DPEBB/Administrator/ServiceType'
//SuperUser
import SuperUserManageServiceCode from '../DPEBB/SuperUser/ManageServiceCode'
import SuperUserManageServiceType from '../DPEBB/SuperUser/ManageServiceType'
import SuperUserManageStandard from '../DPEBB/SuperUser/ManageTax';
import SuperUserManageProviders from '../DPEBB/SuperUser/ManageProviders';
import SuperUserManageClinics from '../DPEBB/SuperUser/ManageClinics';
// import SuperUserManageHsnQdse from '../DPEBB/SuperUser/ManageHsnQdse';
import SuperUserManageCdss from '../DPEBB/SuperUser/ManageCdss';
import SuperUserManageBulletins from '../DPEBB/SuperUser/ManageBulletins';
import SuperUserManagerUser from '../DPEBB/SuperUser/ManageUser';
import SuperUserManagerRolePer from '../DPEBB/SuperUser/ManageRolePermissions';
import SuperUserManagePassword from '../DPEBB/SuperUser/ManageUserPassword';
import SuperUserManageUserRoles from '../DPEBB/SuperUser/ManageUserRoles';
//SystemAdmin
import AdminManageServiceCode from '../DPEBB/Administrator/ManageServiceCode'
import AdminManageServiceType from '../DPEBB/Administrator/ManageServiceType'
import AdminManageStandard from '../DPEBB/Administrator/ManageTax';
import AdminUserManageProviders from '../DPEBB/Administrator/ManageProviders';
import AdminUserManageClinics from '../DPEBB/Administrator/ManageClinics';
import AdministratorManageCdss from '../DPEBB/Administrator/ManageCdss';


// import AdminManageHsnQdse from '../DPEBB/Administrator/ManageHsnQdse';
import AdminUserManageBulletins from '../DPEBB/Administrator/ManageBulletins';
import AdminManagerUser from '../DPEBB/Administrator/ManageUser';
import AdminManagerRolePer from '../DPEBB/Administrator/ManageRolePermissions';
import AdminUserManageUserRoles from '../DPEBB/Administrator/ManageUserRoles';
//Assessor
import AssessorViewServiceCode from '../DPEBB/Assessor/ViewServiceCode';
import AssessorViewServiceType from '../DPEBB/Assessor/ViewServiceType'
import AssessorViewTaxStandard from '../DPEBB/Assessor/ViewTaxStandard';
import AssessorViewProviders from '../DPEBB/Assessor/ViewProviders';
import AssessorViewClinics from '../DPEBB/Assessor/ViewClinics';
import AssessorManageCdss from '@/DPEBB/Assessor/ManageCdss';
//LeadAssessor
import LeadAssessorViewServiceCode from '../DPEBB/LeadAssessor/ViewServiceCode';
import LeadAssessorViewServiceType from '../DPEBB/LeadAssessor/ViewServiceType'
import LeadAssessorViewTaxStandard from '../DPEBB/LeadAssessor/ViewTaxStandard';
import LeadAssessorViewProviders from '../DPEBB/LeadAssessor/ViewProviders';
import LeadAssessorViewClinics from '../DPEBB/LeadAssessor/ViewClinics';  
import LeadManageCdss from '@/DPEBB/LeadAssessor/ManageCdss';



//Policy
import DPEBBPolicyViewServiceCode from '../DPEBB/Policy/ViewServiceCode';
import DPEBBPolicyViewServiceType from '../DPEBB/Policy/ViewServiceType'
import DPEBBPolicyViewTaxStandard from '../DPEBB/Policy/ViewTaxStandard';
import DPEBBPolicyViewProviders from '../DPEBB/Policy/ViewProviders';
import DPEBBPolicyViewClinics from '../DPEBB/Policy/ViewClinics';
import PlicyManageCdss from '@/DPEBB/Policy/ManageCdss';
//Finance
import FinanceDPEBBPaylist from '@/DPEBB/Finance/ViewAllPayList';
import FinanceDPEBBManageClinic from '@/DPEBB/Finance/ManageClinic';
//HelpDesk
import HelpDeskManagePassword from '../DPEBB/HelpDesk/ManageUserPassword';





//WIP

//import DentalPriorApproval from '../components/Dental/PriorApproval';



// import  PriorApprovalDetail from '../components/Dental/PADetail';



import { store } from '../Store/store';
Vue.use(Router);
export const router =  new Router( {mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: Login
    // },
    {
      name: 'home',
      path: '/login',
      public: true,
      components: { default: Login}
    },
    // file downlaod DPFileDownLoad 
    {
      name: 'DPFileDownLoad',
      path: '/DPEBB/FileManager/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    // {
    //   name: 'DPEBBGreenScreenHome',
    //   path: '/DPEBB/DPEBBGreenScreenHome',
    //   components: { default: DPEBBGreenScreenHome}
    // },

    // file downlaod DPFileDownLoad
    {
      name: 'DPFileAdminDownLoad',
      path: '/DPEBB/FileAdministrator/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    // file downlaod DPFileDownLoad
    {
    name: 'DPFilesuperDownLoad',
    path: '/DPEBB/SuperUser/FilesDownload',
    components: { default: DPFileDownLoad}
  },

    ////DPEBB/Finance/FilesDownload
    // file downlaod DPFileDownLoad
    { 
      name: 'DPFileFinanaceDownLoad',
      path: '/DPEBB/Finance/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    // file downlaod DPFileDownLoad
    { 
      name: 'DPFileLeadDownLoad',
      path: '/DPEBB/LeadAssessor/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    //  DpebbFaq DpebbContactus
    {
      name: 'DpebbFaq',
      path: '/DPEBB/Faq',
      components: { default: DpebbFaq}
    },
    {
      name: 'DpebbContactus',
      path: '/DPEBB/Contactus',
      components: { default: DpebbContactus}
    },

    //Dental
    {
      name: 'DentalHome',
      path: '/dental/Home',
      components: { default: DentalHome},
    },
    //SuperUser  
    {
      name: 'SuperUserDentalPriorApproval',
      path: '/Dental/SuperUser/PriorApproval',
      components: { default: SuperUserDentalPriorApproval},
    },
    {
      name:'SuperUserDentalAddClaim',
      path:'/Dental/SuperUser/AddClaim',
      components:{default:SuperUserDentalAddClaim}
    },
    {
      name:'SuperUserDentalVoidClaim',
      path:'/Dental/SuperUser/VoidClaim',
      components:{default:SuperUserDentalVoidClaim}
    },
    {
      name:'SuperUserDentalPatientHistory',
      path:'/Dental/SuperUser/PatientHistory',
      components:{default:SuperUserDentalPatientHistory}
    },
    {
      name:'SuperUserDentalPatientEligibility',
      path:'/Dental/SuperUser/PatientEligibility',
      components:{default:SuperUserDentalPatientEligibility}
    },
    { 
      name: 'SuperUserDentalPatientSummary',
      path: '/Dental/SuperUser/PatientSummary',
      components: { default: SuperUserDentalPatientSummary},
    },
    {
      name:'SuperUserDentalPaylist',
      path:'/Dental/SuperUser/Paylist',
      components:{ default: SuperUserDentalPaylist}
    },
    {
      name: 'SuperUserDentalManagePatientNotes',
      path: '/Dental/SuperUser/ManagePatientNotes',
      components: { default: SuperUserDentalManagePatientNotes},
    },
    {
      name:'SuperUserDentalPatientCoverage',
      path:'/Dental/SuperUser/PatientCoverage',
      components:{default:SuperUserDentalPatientCoverage}
    },
    {
      name:'SuperUserDentalViewBulletins',
      path:'/Dental/SuperUser/ViewBulletins',
      components:{default:SuperUserDentalViewBulletins}
    },
    ///Assessor
    {
      name: 'AssessorDentalPriorApproval',
      path: '/Dental/Assessor/PriorApproval',
      components: { default: AssessorDentalPriorApproval},
    },
    {
      name:'AssessorUserDentalAddClaim',
      path:'/Dental/Assessor/AddClaim',
      components:{default:AssessorUserDentalAddClaim}
    },
    {
      name:'AssessorUserDentalVoidClaim',
      path:'/Dental/Assessor/VoidClaim',
      components:{default:AssessorUserDentalVoidClaim}
    },
    {
      name:'AssessorDentalPatientHistory',
      path:'/Dental/Assessor/PatientHistory',
      components:{default:AssessorDentalPatientHistory}
    },
    {
      name:'AssessorDentalPatientEligibility',
      path:'/Dental/Assessor/PatientEligibility',
      components:{default:AssessorDentalPatientEligibility}
    },
    { 
      name: 'AssessorDentalPatientSummary',
      path: '/Dental/Assessor/PatientSummary',
      components: { default: AssessorDentalPatientSummary},
    },
    { 
      name: 'AssessorDentalPaylist',
      path: '/Dental/Assessor/Paylist',
      components: { default: AssessorDentalPaylist},
    },
    {
      name: 'AssessorDentalManagePatientNotes',
      path: '/Dental/Assessor/ManagePatientNotes',
      components: { default: AssessorDentalManagePatientNotes},
    },
    { 
      name: 'AssessorDentalPatientCoverage',
      path: '/Dental/Assessor/PatientCoverage',
      components: { default: AssessorDentalPatientCoverage},
    },
    {
      name:'AssessorDentalViewBulletins',
      path:'/Dental/Assessor/ViewBulletins',
      components:{default:AssessorDentalViewBulletins}
    },
    //LeadAssessor 
    {
      name: 'LeadAssessorDentalPriorApproval',
      path: '/Dental/LeadAssessor/PriorApproval',
      components: { default: LeadAssessorDentalPriorApproval},
    },
    {
      name:'LeadAssessorUserDentalAddClaim',
      path:'/Dental/LeadAssessor/AddClaim',
      components:{default:LeadAssessorUserDentalAddClaim}
    },
    {
      name:'LeadAssessorUserDentalVoidClaim',
      path:'/Dental/LeadAssessor/VoidClaim',
      components:{default:LeadAssessorUserDentalVoidClaim}
    },
    {
      name:'LeadAssessorDentalPatientHistory',
      path:'/Dental/LeadAssessor/PatientHistory',
      components:{default:LeadAssessorDentalPatientHistory}
    },
    {
      name:'LeadAssessorDentalPatientEligibility',
      path:'/Dental/LeadAssessor/PatientEligibility',
      components:{default:LeadAssessorDentalPatientEligibility}
    },
    { 
      name: 'LeadAssessorDentalPatientSummary',
      path: '/Dental/LeadAssessor/PatientSummary',
      components: { default: LeadAssessorDentalPatientSummary},
    },
    { 
      name: 'LeadAssessorDentalPaylist',
      path: '/Dental/LeadAssessor/Paylist',
      components: { default: LeadAssessorDentalPaylist},
    },
    {
      name: 'LeadAssessorDentalManagePatientNotes',
      path: '/Dental/LeadAssessor/ManagePatientNotes',
      components: { default: LeadAssessorDentalManagePatientNotes},
    },
    { 
      name: 'LeadAssessorDentalPatientCoverage',
      path: '/Dental/LeadAssessor/PatientCoverage',
      components: { default: LeadAssessorDentalPatientCoverage},
    },
    {
      name:'LeadAssessorDentalViewBulletins',
      path:'/Dental/LeadAssessor/ViewBulletins',
      components:{default:LeadAssessorDentalViewBulletins}
    },
    //Policy
    {
      name:'PolicyDentalPatientHistory',
      path:'/Dental/Policy/PatientHistory',
      components:{default:PolicyDentalPatientHistory}
    },
    {
      name:'PolicyDentalPatientEligibility',
      path:'/Dental/Policy/PatientEligibility',
      components:{default:PolicyDentalPatientEligibility}
    },
    { 
      name: 'PolicyDentalPatientSummary',
      path: '/Dental/Policy/PatientSummary',
      components: { default: PolicyDentalPatientSummary},
    },
    {
      name: 'DPEBBPolicyDentalViewPatientNotes',
      path: '/Dental/Policy/ViewPatientNotes',
      components: { default: DPEBBPolicyDentalViewPatientNotes},
    },
    { 
      name: 'PolicyDentalPatientCoverage',
      path: '/Dental/Policy/PatientCoverage',
      components: { default: PolicyDentalPatientCoverage},
    },
    {
      name:'PolicyDentalViewBulletins',
      path:'/Dental/Policy/ViewBulletins',
      components:{default:PolicyDentalViewBulletins}
    },
    //Finance
    { 
      name: 'FinanceDentalPaylist',
      path: '/Dental/Finance/Paylist',
      components: { default: FinanceDentalPaylist},
    },
    {
      name:'FinanceDentalViewBulletins',
      path:'/Dental/Finance/ViewBulletins',
      components:{default:FinanceDentalViewBulletins}
    },
    //Labs
    {
      name:'LabsDentalAddClaim',
      path:'/Dental/Labs/AddClaim',
      components:{default:LabsDentalAddClaim}
    },
    {
      name:'LabsDentalVoidClaim',
      path:'/Dental/Labs/VoidClaim',
      components:{default:LabsDentalVoidClaim}
    },
    {
      name:'LabsDentalViewBulletins',
      path:'/Dental/Labs/ViewBulletins',
      components:{default:LabsDentalViewBulletins}
    },
    {
      name:'LabsDentalPatientHistory',
      path:'/Dental/Labs/PatientHistory',
      components:{default:LabsDentalPatientHistory}
    },
    //Provider
    {
      name: 'ProviderDentalPriorApproval',
      path: '/Dental/Provider/PriorApproval',
      components: { default: ProviderDentalPriorApproval},
    },
    {
      name:'ProviderDentalAddClaim',
      path:'/Dental/Provider/AddClaim',
      components:{default:ProviderDentalAddClaim}
    },
    {
      name:'ProviderDentalVoidClaim',
      path:'/Dental/Provider/VoidClaim',
      components:{default:ProviderDentalVoidClaim}
    },
    {
      name:'ProviderDentalPatientHistory',
      path:'/Dental/Provider/PatientHistory',
      components:{default: ProviderDentalPatientHistory}
      
    },
    {
      name:'ProviderDentalPatientEligibility',
      path:'/Dental/Provider/PatientEligibility',
      components:{default:ProviderDentalPatientEligibility}
    },
    { 
      name: 'ProviderDentalPatientSummary',
      path: '/Dental/Provider/PatientSummary',
      components: { default: ProviderDentalPatientSummary},
    },
    { 
      name: 'ProviderDentalPaylist',
      path: '/Dental/Provider/Paylist',
      components: { default: ProviderDentalPaylist},
    },
    {
      name:'ProviderDentalViewBulletins',
      path:'/Dental/Provider/ViewBulletins',
      components:{default:ProviderDentalViewBulletins}
    },
    //Medical
    {
      name: 'MedicalHome',
      path: '/MedicalSupply/Home',
      components: { default: MedicalHome},
    },
  
    //SuperUser
    {
      name: 'SuperUserMedicalSupplyPriorApproval',
      path: '/MedicalSupply/SuperUser/PriorApproval',
      components: { default: SuperUserMedicalSupplyPriorApproval},
    },
    {
      name:'SuperUserMedicalSupplyAddClaim',
      path:'/MedicalSupply/SuperUser/AddClaim',
      components:{default:SuperUserMedicalSupplyAddClaim}
    },
    {
      name:'SuperUserMedicalSupplyVoidClaim',
      path:'/MedicalSupply/SuperUser/VoidClaim',
      components:{default:SuperUserMedicalSupplyVoidClaim}
    },
    {
      name:'SuperUserMedicalSupplyPatientHistory',
      path:'/MedicalSupply/SuperUser/PatientHistory',
      components:{default:SuperUserMedicalSupplyPatientHistory}
    },
    {
      name:'SuperUserMedicalSupplyPatientEligibility',
      path:'/MedicalSupply/SuperUser/PatientEligibility',
      components:{default:SuperUserMedicalSupplyPatientEligibility}
    },
    { 
      name: 'SuperUserMedicalSupplyPatientSummary',
      path: '/MedicalSupply/SuperUser/PatientSummary',
      components: { default: SuperUserMedicalSupplyPatientSummary},
    },
    {
      name:'SuperUserMedicalSupplyPaylist',
      path:'/MedicalSupply/SuperUser/Paylist',
      components:{ default: SuperUserMedicalSupplyPaylist}
    },
    {
      name: 'SuperUserMedicalSupplyManagePatientNotes',
      path: '/MedicalSupply/SuperUser/ManagePatientNotes',
      components: { default: SuperUserMedicalSupplyManagePatientNotes},
    },
    {
      name:'SuperUserMedicalSupplyPatientCoverage',
      path:'/MedicalSupply/SuperUser/PatientCoverage',
      components:{default:SuperUserMedicalSupplyPatientCoverage}
    },
    {
      name:'SuperUserMedicalSupplyViewBulletins',
      path:'/MedicalSupply/SuperUser/ViewBulletins',
      components:{default:SuperUserMedicalSupplyViewBulletins}
    },
    ///Assessor
    {
      name: 'AssessorMedicalSupplyPriorApproval',
      path: '/MedicalSupply/Assessor/PriorApproval',
      components: { default: AssessorMedicalSupplyPriorApproval},
    },
    {
      name:'AssessorUserMedicalSupplyAddClaim',
      path:'/MedicalSupply/Assessor/AddClaim',
      components:{default:AssessorUserMedicalSupplyAddClaim}
    },
    {
      name:'AssessorUserMedicalSupplyVoidClaim',
      path:'/MedicalSupply/Assessor/VoidClaim',
      components:{default:AssessorUserMedicalSupplyVoidClaim}
    },
    {
      name:'AssessorMedicalSupplyPatientHistory',
      path:'/MedicalSupply/Assessor/PatientHistory',
      components:{default:AssessorMedicalSupplyPatientHistory}
    },
    {
      name:'AssessorMedicalSupplyPatientEligibility',
      path:'/MedicalSupply/Assessor/PatientEligibility',
      components:{default:AssessorMedicalSupplyPatientEligibility}
    },
    { 
      name: 'AssessorMedicalSupplyPatientSummary',
      path: '/MedicalSupply/Assessor/PatientSummary',
      components: { default: AssessorMedicalSupplyPatientSummary},
    },
    { 
      name: 'AssessorMedicalSupplyPaylist',
      path: '/MedicalSupply/Assessor/Paylist',
      components: { default: AssessorMedicalSupplyPaylist},
    },
    {
      name: 'AssessorMedicalSupplyManagePatientNotes',
      path: '/MedicalSupply/Assessor/ManagePatientNotes',
      components: { default: AssessorMedicalSupplyManagePatientNotes},
    },
    { 
      name: 'AssessorMedicalSupplyPatientCoverage',
      path: '/MedicalSupply/Assessor/PatientCoverage',
      components: { default: AssessorMedicalSupplyPatientCoverage},
    },
    {
      name:'AssessorMedicalSupplyViewBulletins',
      path:'/MedicalSupply/Assessor/ViewBulletins',
      components:{default:AssessorMedicalSupplyViewBulletins}
    },
    //LeadAssessor 
    {
      name: 'LeadAssessorMedicalSupplyPriorApproval',
      path: '/MedicalSupply/LeadAssessor/PriorApproval',
      components: { default: LeadAssessorMedicalSupplyPriorApproval},
    },
    {
      name:'LeadAssessorUserMedicalSupplyAddClaim',
      path:'/MedicalSupply/LeadAssessor/AddClaim',
      components:{default:LeadAssessorUserMedicalSupplyAddClaim}
    },
    {
      name:'LeadAssessorUserMedicalSupplyVoidClaim',
      path:'/MedicalSupply/LeadAssessor/VoidClaim',
      components:{default:LeadAssessorUserMedicalSupplyVoidClaim}
    },
    {
      name:'LeadAssessorMedicalSupplyPatientHistory',
      path:'/MedicalSupply/LeadAssessor/PatientHistory',
      components:{default:LeadAssessorMedicalSupplyPatientHistory}
    },
    {
      name:'LeadAssessorMedicalSupplyPatientEligibility',
      path:'/MedicalSupply/LeadAssessor/PatientEligibility',
      components:{default:LeadAssessorMedicalSupplyPatientEligibility}
    },
    { 
      name: 'LeadAssessorMedicalSupplyPatientSummary',
      path: '/MedicalSupply/LeadAssessor/PatientSummary',
      components: { default: LeadAssessorMedicalSupplyPatientSummary},
    },
    { 
      name: 'LeadAssessorMedicalSupplyPaylist',
      path: '/MedicalSupply/LeadAssessor/Paylist',
      components: { default: LeadAssessorMedicalSupplyPaylist},
    },
    {
      name: 'LeadAssessorMedicalSupplyManagePatientNotes',
      path: '/MedicalSupply/LeadAssessor/ManagePatientNotes',
      components: { default: LeadAssessorMedicalSupplyManagePatientNotes},
    },
    { 
      name: 'LeadAssessorMedicalSupplyPatientCoverage',
      path: '/MedicalSupply/LeadAssessor/PatientCoverage',
      components: { default: LeadAssessorMedicalSupplyPatientCoverage},
    },
    {
      name:'LeadAssessorMedicalSupplyViewBulletins',
      path:'/MedicalSupply/LeadAssessor/ViewBulletins',
      components:{default:LeadAssessorMedicalSupplyViewBulletins}
    },
    //Policy
    {
      name:'PolicyMedicalSupplyPatientHistory',
      path:'/MedicalSupply/Policy/PatientHistory',
      components:{default:PolicyMedicalSupplyPatientHistory}
    },
    {
      name:'PolicyMedicalSupplyPatientEligibility',
      path:'/MedicalSupply/Policy/PatientEligibility',
      components:{default:PolicyMedicalSupplyPatientEligibility}
    },
    { 
      name: 'PolicyMedicalSupplyPatientSummary',
      path: '/MedicalSupply/Policy/PatientSummary',
      components: { default: PolicyMedicalSupplyPatientSummary},
    },
    {
      name: 'DPEBBPolicyMedicalSupplyViewPatientNotes',
      path: '/MedicalSupply/Policy/ViewPatientNotes',
      components: { default: DPEBBPolicyMedicalSupplyViewPatientNotes},
    },
    { 
      name: 'PolicyMedicalSupplyPatientCoverage',
      path: '/MedicalSupply/Policy/PatientCoverage',
      components: { default: PolicyMedicalSupplyPatientCoverage},
    },
    {
      name:'PolicyMedicalSupplyViewBulletins',
      path:'/MedicalSupply/Policy/ViewBulletins',
      components:{default:PolicyMedicalSupplyViewBulletins}
    },
    //Finance
    { 
      name: 'FinanceMedicalSupplyPaylist',
      path: '/MedicalSupply/Finance/Paylist',
      components: { default: FinanceMedicalSupplyPaylist},
    },
    {
      name:'FinanceMedicalSupplyViewBulletins',
      path:'/MedicalSupply/Finance/ViewBulletins',
      components:{default:FinanceMedicalSupplyViewBulletins}
    },
    //Labs
    {
      name:'LabsMedicalSupplyAddClaim',
      path:'/MedicalSupply/Labs/AddClaim',
      components:{default:LabsMedicalSupplyAddClaim}
    },
    {
      name:'LabsMedicalSupplyVoidClaim',
      path:'/MedicalSupply/Labs/VoidClaim',
      components:{default:LabsMedicalSupplyVoidClaim}
    },
    {
      name:'LabsMedicalSupplyViewBulletins',
      path:'/MedicalSupply/Labs/ViewBulletins',
      components:{default:LabsMedicalSupplyViewBulletins}
    },
    //Provider
    {
      name: 'ProviderMedicalSupplyPriorApproval',
      path: '/MedicalSupply/Provider/PriorApproval',
      components: { default: ProviderMedicalSupplyPriorApproval},
    },
    {
      name:'ProviderMedicalSupplyAddClaim',
      path:'/MedicalSupply/Provider/AddClaim',
      components:{default:ProviderMedicalSupplyAddClaim}
    },
    {
      name:'ProviderMedicalSupplyVoidClaim',
      path:'/MedicalSupply/Provider/VoidClaim',
      components:{default:ProviderMedicalSupplyVoidClaim}
    },
    {
      name:'ProviderMedicalSupplyPatientHistory',
      path:'/MedicalSupply/Provider/PatientHistory',
      components:{default:ProviderMedicalSupplyPatientHistory}
    },
    {
      name:'ProviderMedicalSupplyPatientEligibility',
      path:'/MedicalSupply/Provider/PatientEligibility',
      components:{default:ProviderMedicalSupplyPatientEligibility}
    },
    { 
      name: 'ProviderMedicalSupplyPatientSummary',
      path: '/MedicalSupply/Provider/PatientSummary',
      components: { default: ProviderMedicalSupplyPatientSummary},
    },
    { 
      name: 'ProviderMedicalSupplyPaylist',
      path: '/MedicalSupply/Provider/Paylist',
      components: { default: ProviderMedicalSupplyPaylist},
    },
    {
      name:'ProviderMedicalSupplyViewBulletins',
      path:'/MedicalSupply/Provider/ViewBulletins',
      components:{default:ProviderMedicalSupplyViewBulletins}
    },

    //Optical
    {
      name: 'OpticalHome',
      path: '/Optical/Home',
      components: { default: OpticalHome},
    },
    
    //SuperUser
    {
      name: 'SuperUserOpticalPriorApproval',
      path: '/Optical/SuperUser/PriorApproval',
      components: { default: SuperUserOpticalPriorApproval},
    },
    {
      name:'SuperUserOpticalAddClaim',
      path:'/Optical/SuperUser/AddClaim',
      components:{default:SuperUserOpticalAddClaim}
    },
    {
      name:'SuperUserOpticalVoidClaim',
      path:'/Optical/SuperUser/VoidClaim',
      components:{default:SuperUserOpticalVoidClaim}
    },
    {
      name:'SuperUserOpticalPatientHistory',
      path:'/Optical/SuperUser/PatientHistory',
      components:{default:SuperUserOpticalPatientHistory}
    },
    {
      name:'SuperUserOpticalPatientEligibility',
      path:'/Optical/SuperUser/PatientEligibility',
      components:{default:SuperUserOpticalPatientEligibility}
    },
    { 
      name: 'SuperUserOpticalPatientSummary',
      path: '/Optical/SuperUser/PatientSummary',
      components: { default: SuperUserOpticalPatientSummary},
    },
    {
      name:'SuperUserOpticalPaylist',
      path:'/Optical/SuperUser/Paylist',
      components:{ default: SuperUserOpticalPaylist}
    },
    {
      name: 'SuperUserOpticalManagePatientNotes',
      path: '/Optical/SuperUser/ManagePatientNotes',
      components: { default: SuperUserOpticalManagePatientNotes},
    },
    {
      name:'SuperUserOpticalPatientCoverage',
      path:'/Optical/SuperUser/PatientCoverage',
      components:{default:SuperUserOpticalPatientCoverage}
    },
    {
      name:'SuperUserOpticalViewBulletins',
      path:'/Optical/SuperUser/ViewBulletins',
      components:{default:SuperUserOpticalViewBulletins}
    },
    ///Assessor
    {
      name: 'AssessorOpticalPriorApproval',
      path: '/Optical/Assessor/PriorApproval',
      components: { default: AssessorOpticalPriorApproval},
    },
    {
      name:'AssessorUserOpticalAddClaim',
      path:'/Optical/Assessor/AddClaim',
      components:{default:AssessorUserOpticalAddClaim}
    },
    {
      name:'AssessorUserOpticalVoidClaim',
      path:'/Optical/Assessor/VoidClaim',
      components:{default:AssessorUserOpticalVoidClaim}
    },
    {
      name:'AssessorOpticalPatientHistory',
      path:'/Optical/Assessor/PatientHistory',
      components:{default:AssessorOpticalPatientHistory}
    },
    {
      name:'AssessorOpticalPatientEligibility',
      path:'/Optical/Assessor/PatientEligibility',
      components:{default:AssessorOpticalPatientEligibility}
    },
    { 
      name: 'AssessorOpticalPatientSummary',
      path: '/Optical/Assessor/PatientSummary',
      components: { default: AssessorOpticalPatientSummary},
    },
    { 
      name: 'AssessorOpticalPaylist',
      path: '/Optical/Assessor/Paylist',
      components: { default: AssessorOpticalPaylist},
    },
    {
      name: 'AssessorOpticalManagePatientNotes',
      path: '/Optical/Assessor/ManagePatientNotes',
      components: { default: AssessorOpticalManagePatientNotes},
    },
    { 
      name: 'AssessorOpticalPatientCoverage',
      path: '/Optical/Assessor/PatientCoverage',
      components: { default: AssessorOpticalPatientCoverage},
    },
    {
      name:'AssessorOpticalViewBulletins',
      path:'/Optical/Assessor/ViewBulletins',
      components:{default:AssessorOpticalViewBulletins}
    },
    //LeadAssessor 
    {
      name: 'LeadAssessorOpticalPriorApproval',
      path: '/Optical/LeadAssessor/PriorApproval',
      components: { default: LeadAssessorOpticalPriorApproval},
    },
    {
      name:'LeadAssessorUserOpticalAddClaim',
      path:'/Optical/LeadAssessor/AddClaim',
      components:{default:LeadAssessorUserOpticalAddClaim}
    },
    {
      name:'LeadAssessorUserOpticalVoidClaim',
      path:'/Optical/LeadAssessor/VoidClaim',
      components:{default:LeadAssessorUserOpticalVoidClaim}
    },
    {
      name:'LeadAssessorOpticalPatientHistory',
      path:'/Optical/LeadAssessor/PatientHistory',
      components:{default: LeadAssessorOpticalPatientHistory}
    },
    {
      name:'LeadAssessorOpticalPatientEligibility',
      path:'/Optical/LeadAssessor/PatientEligibility',
      components:{default:LeadAssessorOpticalPatientEligibility}
    },
    { 
      name: 'LeadAssessorOpticalPatientSummary',
      path: '/Optical/LeadAssessor/PatientSummary',
      components: { default: LeadAssessorOpticalPatientSummary},
    },
    { 
      name: 'LeadAssessorOpticalPaylist',
      path: '/Optical/LeadAssessor/Paylist',
      components: { default: LeadAssessorOpticalPaylist},
    },
    {
      name: 'LeadAssessorOpticalManagePatientNotes',
      path: '/Optical/LeadAssessor/ManagePatientNotes',
      components: { default: LeadAssessorOpticalManagePatientNotes},
    },
    { 
      name: 'LeadAssessorOpticalPatientCoverage',
      path: '/Optical/LeadAssessor/PatientCoverage',
      components: { default: LeadAssessorOpticalPatientCoverage},
    },
    {
      name:'LeadAssessorOpticalViewBulletins',
      path:'/Optical/LeadAssessor/ViewBulletins',
      components:{default:LeadAssessorOpticalViewBulletins}
    },
    //Policy
    {
      name:'PolicyOpticalPatientHistory',
      path:'/Optical/Policy/PatientHistory',
      components:{default:PolicyOpticalPatientHistory}
    },
    {
      name:'PolicyOpticalPatientEligibility',
      path:'/Optical/Policy/PatientEligibility',
      components:{default:PolicyOpticalPatientEligibility}
    },
    { 
      name: 'PolicyOpticalPatientSummary',
      path: '/Optical/Policy/PatientSummary',
      components: { default: PolicyOpticalPatientSummary},
    },
    {
      name: 'DPEBBPolicyOpticalViewPatientNotes',
      path: '/Optical/Policy/ViewPatientNotes',
      components: { default: DPEBBPolicyOpticalViewPatientNotes},
    },
    { 
      name: 'PolicyOpticalPatientCoverage',
      path: '/Optical/Policy/PatientCoverage',
      components: { default: PolicyOpticalPatientCoverage},
    },
    {
      name:'PolicyOpticalViewBulletins',
      path:'/Optical/Policy/ViewBulletins',
      components:{default:PolicyOpticalViewBulletins}
    },
    //Finance
    { 
      name: 'FinanceOpticalPaylist',
      path: '/Optical/Finance/Paylist',
      components: { default: FinanceOpticalPaylist},
    },
    {
      name:'FinanceOpticalViewBulletins',
      path:'/Optical/Finance/ViewBulletins',
      components:{default:FinanceOpticalViewBulletins}
    },
    //Labs
    {
      name:'LabsOpticalAddClaim',
      path:'/Optical/Labs/AddClaim',
      components:{default:LabsOpticalAddClaim}
    },
    {
      name:'LabsOpticalVoidClaim',
      path:'/Optical/Labs/VoidClaim',
      components:{default:LabsOpticalVoidClaim}
    },
    {
      name:'LabsOpticalViewBulletins',
      path:'/Optical/Labs/ViewBulletins',
      components:{default:LabsOpticalViewBulletins}
    },
    //Provider
    {
      name: 'ProviderOpticalPriorApproval',
      path: '/Optical/Provider/PriorApproval',
      components: { default: ProviderOpticalPriorApproval},
    },
    {
      name:'ProviderOpticalAddClaim',
      path:'/Optical/Provider/AddClaim',
      components:{default:ProviderOpticalAddClaim}
    },
    {
      name:'ProviderOpticalVoidClaim',
      path:'/Optical/Provider/VoidClaim',
      components:{default:ProviderOpticalVoidClaim}
    },
    {
      name:'ProviderOpticalPatientHistory',
      path:'/Optical/Provider/PatientHistory',
      components:{default:ProviderOpticalPatientHistory}
    },
    {
      name:'ProviderOpticalPatientEligibility',
      path:'/Optical/Provider/PatientEligibility',
      components:{default:ProviderOpticalPatientEligibility}
    },
    { 
      name: 'ProviderOpticalPatientSummary',
      path: '/Optical/Provider/PatientSummary',
      components: { default: ProviderOpticalPatientSummary},
    },
    { 
      name: 'ProviderOpticalPaylist',
      path: '/Optical/Provider/Paylist',
      components: { default: ProviderOpticalPaylist},
    },
    {
      name:'ProviderOpticalViewBulletins',
      path:'/Optical/Provider/ViewBulletins',
      components:{default:ProviderOpticalViewBulletins}
    },
    //Hearing
    {
      name: 'HearingHome',
      path: '/Hearing/Home',
      components: { default: HearingHome},
    },
    //SuperUser
    {
      name: 'SuperUserHearingPriorApproval',
      path: '/Hearing/SuperUser/PriorApproval',
      components: { default: SuperUserHearingPriorApproval},
    },
    {
      name:'SuperUserHearingAddClaim',
      path:'/Hearing/SuperUser/AddClaim',
      components:{default:SuperUserHearingAddClaim}
    },
    {
      name:'SuperUserHearingVoidClaim',
      path:'/Hearing/SuperUser/VoidClaim',
      components:{default:SuperUserHearingVoidClaim}
    },
    {
      name:'SuperUserHearingPatientHistory',
      path:'/Hearing/SuperUser/PatientHistory',
      components:{default:SuperUserHearingPatientHistory}
    },
    {
      name:'SuperUserHearingPatientEligibility',
      path:'/Hearing/SuperUser/PatientEligibility',
      components:{default:SuperUserHearingPatientEligibility}
    },
    { 
      name: 'SuperUserHearingPatientSummary',
      path: '/Hearing/SuperUser/PatientSummary',
      components: { default: SuperUserHearingPatientSummary},
    },
    {
      name:'SuperUserHearingPaylist',
      path:'/Hearing/SuperUser/Paylist',
      components:{ default: SuperUserHearingPaylist}
    },
    {
      name: 'SuperUserHearingManagePatientNotes',
      path: '/Hearing/SuperUser/ManagePatientNotes',
      components: { default: SuperUserHearingManagePatientNotes},
    },
    {
      name:'SuperUserHearingPatientCoverage',
      path:'/Hearing/SuperUser/PatientCoverage',
      components:{default:SuperUserHearingPatientCoverage}
    },
    {
      name:'SuperUserHearingViewBulletins',
      path:'/Hearing/SuperUser/ViewBulletins',
      components:{default:SuperUserHearingViewBulletins}
    },
    ///Assessor
    {
      name: 'AssessorHearingPriorApproval',
      path: '/Hearing/Assessor/PriorApproval',
      components: { default: AssessorHearingPriorApproval},
    },
    {
      name:'AssessorUserHearingAddClaim',
      path:'/Hearing/Assessor/AddClaim',
      components:{default:AssessorUserHearingAddClaim}
    },
    {
      name:'AssessorUserHearingVoidClaim',
      path:'/Hearing/Assessor/VoidClaim',
      components:{default:AssessorUserHearingVoidClaim}
    },
    {
      name:'AssessorHearingPatientHistory',
      path:'/Hearing/Assessor/PatientHistory',
      components:{default:AssessorHearingPatientHistory}
    },
    {
      name:'AssessorHearingPatientEligibility',
      path:'/Hearing/Assessor/PatientEligibility',
      components:{default:AssessorHearingPatientEligibility}
    },
    { 
      name: 'AssessorHearingPatientSummary',
      path: '/Hearing/Assessor/PatientSummary',
      components: { default: AssessorHearingPatientSummary},
    },
    { 
      name: 'AssessorHearingPaylist',
      path: '/Hearing/Assessor/Paylist',
      components: { default: AssessorHearingPaylist},
    },
    {
      name: 'AssessorHearingManagePatientNotes',
      path: '/Hearing/Assessor/ManagePatientNotes',
      components: { default: AssessorHearingManagePatientNotes},
    },
    { 
      name: 'AssessorHearingPatientCoverage',
      path: '/Hearing/Assessor/PatientCoverage',
      components: { default: AssessorHearingPatientCoverage},
    },
    {
      name:'AssessorHearingViewBulletins',
      path:'/Hearing/Assessor/ViewBulletins',
      components:{default:AssessorHearingViewBulletins}
    },
    //LeadAssessor 
    {
      name: 'LeadAssessorHearingPriorApproval',
      path: '/Hearing/LeadAssessor/PriorApproval',
      components: { default: LeadAssessorHearingPriorApproval},
    },
    {
      name:'LeadAssessorUserHearingAddClaim',
      path:'/Hearing/LeadAssessor/AddClaim',
      components:{default:LeadAssessorUserHearingAddClaim}
    },
    {
      name:'LeadAssessorUserHearingVoidClaim',
      path:'/Hearing/LeadAssessor/VoidClaim',
      components:{default:LeadAssessorUserHearingVoidClaim}
    },
    {
      name:'LeadAssessorHearingPatientHistory',
      path:'/Hearing/LeadAssessor/PatientHistory',
      components:{default:LeadAssessorHearingPatientHistory}
    },
    {
      name:'LeadAssessorHearingPatientEligibility',
      path:'/Hearing/LeadAssessor/PatientEligibility',
      components:{default:LeadAssessorHearingPatientEligibility}
    },
    { 
      name: 'LeadAssessorHearingPatientSummary',
      path: '/Hearing/LeadAssessor/PatientSummary',
      components: { default: LeadAssessorHearingPatientSummary},
    },
    { 
      name: 'LeadAssessorHearingPaylist',
      path: '/Hearing/LeadAssessor/Paylist',
      components: { default: LeadAssessorHearingPaylist},
    },
    {
      name: 'LeadAssessorHearingManagePatientNotes',
      path: '/Hearing/LeadAssessor/ManagePatientNotes',
      components: { default: LeadAssessorHearingManagePatientNotes},
    },
    { 
      name: 'LeadAssessorHearingPatientCoverage',
      path: '/Hearing/LeadAssessor/PatientCoverage',
      components: { default: LeadAssessorHearingPatientCoverage},
    },
    {
      name:'LeadAssessorHearingViewBulletins',
      path:'/Hearing/LeadAssessor/ViewBulletins',
      components:{default:LeadAssessorHearingViewBulletins}
    },
    //Policy
    {
      name:'PolicyHearingPatientHistory',
      path:'/Hearing/Policy/PatientHistory',
      components:{default:PolicyHearingPatientHistory}
    },
    {
      name:'PolicyHearingPatientEligibility',
      path:'/Hearing/Policy/PatientEligibility',
      components:{default:PolicyHearingPatientEligibility}
    },
    { 
      name: 'PolicyHearingPatientSummary',
      path: '/Hearing/Policy/PatientSummary',
      components: { default: PolicyHearingPatientSummary},
    },
    {
      name: 'DPEBBPolicyHearingViewPatientNotes',
      path: '/Hearing/Policy/ViewPatientNotes',
      components: { default: DPEBBPolicyHearingViewPatientNotes},
    },
    { 
      name: 'PolicyHearingPatientCoverage',
      path: '/Hearing/Policy/PatientCoverage',
      components: { default: PolicyHearingPatientCoverage},
    },
    {
      name:'PolicyHearingViewBulletins',
      path:'/Hearing/Policy/ViewBulletins',
      components:{default:PolicyHearingViewBulletins}
    },
    //Finance
    { 
      name: 'FinanceHearingPaylist',
      path: '/Hearing/Finance/Paylist',
      components: { default: FinanceHearingPaylist},
    },
    {
      name:'FinanceHearingViewBulletins',
      path:'/Hearing/Finance/ViewBulletins',
      components:{default:FinanceHearingViewBulletins}
    },
    //Labs
    {
      name:'LabsHearingAddClaim',
      path:'/Hearing/Labs/AddClaim',
      components:{default:LabsHearingAddClaim}
    },
    {
      name:'LabsHearingVoidClaim',
      path:'/Hearing/Labs/VoidClaim',
      components:{default:LabsHearingVoidClaim}
    },
    {
      name:'LabsHearingViewBulletins',
      path:'/Hearing/Labs/ViewBulletins',
      components:{default:LabsHearingViewBulletins}
    },
    //Provider
    {
      name: 'ProviderHearingPriorApproval',
      path: '/Hearing/Provider/PriorApproval',
      components: { default: ProviderHearingPriorApproval},
    },
    {
      name:'ProviderHearingAddClaim',
      path:'/Hearing/Provider/AddClaim',
      components:{default:ProviderHearingAddClaim}
    },
    {
      name:'ProviderHearingVoidClaim',
      path:'/Hearing/Provider/VoidClaim',
      components:{default:ProviderHearingVoidClaim}
    },
    {
      name:'ProviderHearingPatientHistory',
      path:'/Hearing/Provider/PatientHistory',
      components:{default:ProviderHearingPatientHistory}
    },
    {
      name:'ProviderHearingPatientEligibility',
      path:'/Hearing/Provider/PatientEligibility',
      components:{default:ProviderHearingPatientEligibility}
    },
    { 
      name: 'ProviderHearingPatientSummary',
      path: '/Hearing/Provider/PatientSummary',
      components: { default: ProviderHearingPatientSummary},
    },
    { 
      name: 'ProviderHearingPaylist',
      path: '/Hearing/Provider/Paylist',
      components: { default: ProviderHearingPaylist},
    },
    {
      name:'ProviderHearingViewBulletins',
      path:'/Hearing/Provider/ViewBulletins',
      components:{default:ProviderHearingViewBulletins}
    },
    //Podiatry
    {
      name: 'PodiatryHome',
      path: '/Podiatry/Home',
      components: { default: PodiatryHome},
    },
 //SuperUser
 {
  name: 'SuperUserPodiatryPriorApproval',
  path: '/Podiatry/SuperUser/PriorApproval',
  components: { default: SuperUserPodiatryPriorApproval},
},
{
  name:'SuperUserPodiatryAddClaim',
  path:'/Podiatry/SuperUser/AddClaim',
  components:{default:SuperUserPodiatryAddClaim}
},
{
  name:'SuperUserPodiatryVoidClaim',
  path:'/Podiatry/SuperUser/VoidClaim',
  components:{default:SuperUserPodiatryVoidClaim}
},
{
  name:'SuperUserPodiatryPatientHistory',
  path:'/Podiatry/SuperUser/PatientHistory',
  components:{default:SuperUserPodiatryPatientHistory}
},
{
  name:'SuperUserPodiatryPatientEligibility',
  path:'/Podiatry/SuperUser/PatientEligibility',
  components:{default:SuperUserPodiatryPatientEligibility}
},
{ 
  name: 'SuperUserPodiatryPatientSummary',
  path: '/Podiatry/SuperUser/PatientSummary',
  components: { default: SuperUserPodiatryPatientSummary},
},
{
  name:'SuperUserPodiatryPaylist',
  path:'/Podiatry/SuperUser/Paylist',
  components:{ default: SuperUserPodiatryPaylist}
},
{
  name: 'SuperUserPodiatryManagePatientNotes',
  path: '/Podiatry/SuperUser/ManagePatientNotes',
  components: { default: SuperUserPodiatryManagePatientNotes},
},
{
  name:'SuperUserPodiatryPatientCoverage',
  path:'/Podiatry/SuperUser/PatientCoverage',
  components:{default:SuperUserPodiatryPatientCoverage}
},
{
  name:'SuperUserPodiatryViewBulletins',
  path:'/Podiatry/SuperUser/ViewBulletins',
  components:{default:SuperUserPodiatryViewBulletins}
},
///Assessor
{
  name: 'AssessorPodiatryPriorApproval',
  path: '/Podiatry/Assessor/PriorApproval',
  components: { default: AssessorPodiatryPriorApproval},
},
{
  name:'AssessorUserPodiatryAddClaim',
  path:'/Podiatry/Assessor/AddClaim',
  components:{default:AssessorUserPodiatryAddClaim}
},
{
  name:'AssessorUserPodiatryVoidClaim',
  path:'/Podiatry/Assessor/VoidClaim',
  components:{default:AssessorUserPodiatryVoidClaim}
},
{
  name:'AssessorPodiatryPatientHistory',
  path:'/Podiatry/Assessor/PatientHistory',
  components:{default:AssessorPodiatryPatientHistory}
},
{
  name:'AssessorPodiatryPatientEligibility',
  path:'/Podiatry/Assessor/PatientEligibility',
  components:{default:AssessorPodiatryPatientEligibility}
},
{ 
  name: 'AssessorPodiatryPatientSummary',
  path: '/Podiatry/Assessor/PatientSummary',
  components: { default: AssessorPodiatryPatientSummary},
},
{ 
  name: 'AssessorPodiatryPaylist',
  path: '/Podiatry/Assessor/Paylist',
  components: { default: AssessorPodiatryPaylist},
},
{
  name: 'AssessorPodiatryManagePatientNotes',
  path: '/Podiatry/Assessor/ManagePatientNotes',
  components: { default: AssessorPodiatryManagePatientNotes},
},
{ 
  name: 'AssessorPodiatryPatientCoverage',
  path: '/Podiatry/Assessor/PatientCoverage',
  components: { default: AssessorPodiatryPatientCoverage},
},
{
  name:'AssessorPodiatryViewBulletins',
  path:'/Podiatry/Assessor/ViewBulletins',
  components:{default:AssessorPodiatryViewBulletins}
},
//LeadAssessor 
{
  name: 'LeadAssessorPodiatryPriorApproval',
  path: '/Podiatry/LeadAssessor/PriorApproval',
  components: { default: LeadAssessorPodiatryPriorApproval},
},
{
  name:'LeadAssessorUserPodiatryAddClaim',
  path:'/Podiatry/LeadAssessor/AddClaim',
  components:{default:LeadAssessorUserPodiatryAddClaim}
},
{
  name:'LeadAssessorUserPodiatryVoidClaim',
  path:'/Podiatry/LeadAssessor/VoidClaim',
  components:{default:LeadAssessorUserPodiatryVoidClaim}
},
{
  name:'LeadAssessorPodiatryPatientHistory',
  path:'/Podiatry/LeadAssessor/PatientHistory',
  components:{default:LeadAssessorPodiatryPatientHistory}
},
{
  name:'LeadAssessorPodiatryPatientEligibility',
  path:'/Podiatry/LeadAssessor/PatientEligibility',
  components:{default:LeadAssessorPodiatryPatientEligibility}
},
{ 
  name: 'LeadAssessorPodiatryPatientSummary',
  path: '/Podiatry/LeadAssessor/PatientSummary',
  components: { default: LeadAssessorPodiatryPatientSummary},
},
{ 
  name: 'LeadAssessorPodiatryPaylist',
  path: '/Podiatry/LeadAssessor/Paylist',
  components: { default: LeadAssessorPodiatryPaylist},
},
{
  name: 'LeadAssessorPodiatryManagePatientNotes',
  path: '/Podiatry/LeadAssessor/ManagePatientNotes',
  components: { default: LeadAssessorPodiatryManagePatientNotes},
},
{ 
  name: 'LeadAssessorPodiatryPatientCoverage',
  path: '/Podiatry/LeadAssessor/PatientCoverage',
  components: { default: LeadAssessorPodiatryPatientCoverage},
},
{
  name:'LeadAssessorPodiatryViewBulletins',
  path:'/Podiatry/LeadAssessor/ViewBulletins',
  components:{default:LeadAssessorPodiatryViewBulletins}
},
//Policy
{
  name:'PolicyPodiatryPatientHistory',
  path:'/Podiatry/Policy/PatientHistory',
  components:{default:PolicyPodiatryPatientHistory}
},
{
  name:'PolicyPodiatryPatientEligibility',
  path:'/Podiatry/Policy/PatientEligibility',
  components:{default:PolicyPodiatryPatientEligibility}
},
{ 
  name: 'PolicyPodiatryPatientSummary',
  path: '/Podiatry/Policy/PatientSummary',
  components: { default: PolicyPodiatryPatientSummary},
},
{
  name: 'DPEBBPolicyPodiatryViewPatientNotes',
  path: '/Podiatry/Policy/ViewPatientNotes',
  components: { default: DPEBBPolicyPodiatryViewPatientNotes},
},
{ 
  name: 'PolicyPodiatryPatientCoverage',
  path: '/Podiatry/Policy/PatientCoverage',
  components: { default: PolicyPodiatryPatientCoverage},
},
{
  name:'PolicyPodiatryViewBulletins',
  path:'/Podiatry/Policy/ViewBulletins',
  components:{default:PolicyPodiatryViewBulletins}
},
//Finance
{ 
  name: 'FinancePodiatryPaylist',
  path: '/Podiatry/Finance/Paylist',
  components: { default: FinancePodiatryPaylist},
},
{
  name:'FinancePodiatryViewBulletins',
  path:'/Podiatry/Finance/ViewBulletins',
  components:{default:FinancePodiatryViewBulletins}
},
//Labs
{
  name:'LabsPodiatryAddClaim',
  path:'/Podiatry/Labs/AddClaim',
  components:{default:LabsPodiatryAddClaim}
},
{
  name:'LabsPodiatryVoidClaim',
  path:'/Podiatry/Labs/VoidClaim',
  components:{default:LabsPodiatryVoidClaim}
},
{
  name:'LabsPodiatryViewBulletins',
  path:'/Podiatry/Labs/ViewBulletins',
  components:{default:LabsPodiatryViewBulletins}
},
//Provider
{
  name: 'ProviderPodiatryPriorApproval',
  path: '/Podiatry/Provider/PriorApproval',
  components: { default: ProviderPodiatryPriorApproval},
},
{
  name:'ProviderPodiatryAddClaim',
  path:'/Podiatry/Provider/AddClaim',
  components:{default:ProviderPodiatryAddClaim}
},
{
  name:'ProviderPodiatryVoidClaim',
  path:'/Podiatry/Provider/VoidClaim',
  components:{default:ProviderPodiatryVoidClaim}
},
{
  name:'ProviderPodiatryPatientHistory',
  path:'/Podiatry/Provider/PatientHistory',
  components:{default:ProviderPodiatryPatientHistory}
},
{
  name:'ProviderPodiatryPatientEligibility',
  path:'/Podiatry/Provider/PatientEligibility',
  components:{default:ProviderPodiatryPatientEligibility}
},
{ 
  name: 'ProviderPodiatryPatientSummary',
  path: '/Podiatry/Provider/PatientSummary',
  components: { default: ProviderPodiatryPatientSummary},
},
{ 
  name: 'ProviderPodiatryPaylist',
  path: '/Podiatry/Provider/Paylist',
  components: { default: ProviderPodiatryPaylist},
},
{
  name:'ProviderPodiatryViewBulletins',
  path:'/Podiatry/Provider/ViewBulletins',
  components:{default:ProviderPodiatryViewBulletins}
},

     //DPEBB
     {
      name: 'DPEBBHome',
      path: '/DPEBB/Home',
      components: { default: DPEBBHome}
    },
    {
      name: 'DPEBBMainHome',
      path: '/DPEBB/MainHome',
      components: { default: DPEBBMainHome},
    //   beforeEnter(to,from,next){
    //     //alert('at route')
    //     //next();
    //       if(store.state.AccessToken || localStorage.getItem("access_token") !== null){
    //       if( localStorage.getItem("access_token") !== null){
    //         next();
    //       }
    //       else{
    //         next('/');
    //       }
    //   }
    // }
    }, 
    {
      name: 'UpdatePassword',
      path: '/UpdatePassword',
      components: { default: UpdatePasswordHome},
    },
    {
      name: 'ServiceType',
      path: '/DPEBB/ServiceType',
      components: { default: ServiceType},
    },
    //SuperUser
    {
      name: 'SuperUserManageServiceCode',
      path:  '/DPEBB/SuperUser/ManageServiceCode',
        components:{default:SuperUserManageServiceCode}
    },
    {
      name: 'SuperUserManageServiceType',
      path: '/DPEBB/SuperUser/ManageServiceType',
      components: { default: SuperUserManageServiceType}
    },
    {  
      name: 'SuperUserManageStandard',
      path: '/DPEBB/SuperUser/ManageTax',
      components: { default: SuperUserManageStandard}
    },
    {
      name:'SuperUserManageProviders',
      path:'/DPEBB/SuperUser/ManageProviders',
      components:{default:SuperUserManageProviders}
    },
    {
      name:'SuperUserManageClinics',
      path: '/DPEBB/SuperUser/ManageClinics',
      components:{default: SuperUserManageClinics}
    },
    // {  
    //   name: 'SuperUserManageHsnQdse',
    //   path: '/DPEBB/SuperUser/ManageHSNQDSE',
    //   components: { default: SuperUserManageHsnQdse}
    // },
    {  
      name: 'SuperUserManageCdss',
      path: '/DPEBB/SuperUser/ManageCdss',
      components: { default: SuperUserManageCdss}
    },
    {  
      name: 'LeadManageCdss',
      path: '/DPEBB/LeadAssessor/ManageCdss',
      components: { default: LeadManageCdss}
    },
    {  
      name: 'AssessorManageCdss',
      path: '/DPEBB/Assessor/ManageCdss',
      components: { default: AssessorManageCdss}
    },
    {  
      name: 'PlicyManageCdss',
      path: '/DPEBB/Policy/ManageCdss',
      components: { default: PlicyManageCdss}
    },

 
    {  
      name: 'AdministratorManageCdss',
      path: '/DPEBB/Administrator/ManageCdss',
      components: { default: AdministratorManageCdss}
    },
    

    {
      name:'SuperUserManageBulletins',
      path:'/DPEBB/SuperUser/ManageBulletins',
      components:{default:SuperUserManageBulletins}
    },
    {
      name: 'SuperUserManagerUser',
      path: '/DPEBB/SuperUser/ManageUsers',
      components: { default: SuperUserManagerUser}
    },
    {
      name: 'SuperUserManagerRolePer',
      path: '/DPEBB/SuperUser/ManageRolePermissions',
      components: { default: SuperUserManagerRolePer}
    },
    {
      name: 'SuperUserManageUserPassword',
      path: '/DPEBB/SuperUser/ManageUserPassword',
      components: { default: SuperUserManagePassword}
    },
    {
      name: 'SuperUserManageUserRoles',
      path: '/DPEBB/SuperUser/ManageUserRoles',
      components: {default:SuperUserManageUserRoles}
    },
    //SystemAdmin
    {
      name: 'AdminManageServiceCode',
      path:  '/DPEBB/Administrator/ManageServiceCode',
        components:{default:AdminManageServiceCode}
    },
    {
      name: 'AdminManageServiceType',
      path:  '/DPEBB/Administrator/ManageServiceType',
        components:{default:AdminManageServiceType}
    },
    {  
      name: 'AdminManageStandard',
      path: '/DPEBB/Administrator/ManageTax',
      components: { default: AdminManageStandard}
    },
    {
      name:'AdminUserManageProviders',
      path:'/DPEBB/Administrator/ManageProviders',
      components:{default:AdminUserManageProviders}
    },
    {
      name:'AdminUserManageClinics',
      path: '/DPEBB/Administrator/ManageClinics',
      components:{default: AdminUserManageClinics}
    },
    // {  
    //   name: 'AdminManageHsnQdse',
    //   path: '/DPEBB/Administrator/ManageHSNQDSE',
    //   components: { default: AdminManageHsnQdse}
    // },
    {
      name:'AdminUserManageBulletins',
      path:'/DPEBB/Administrator/ManageBulletins',
      components:{default:AdminUserManageBulletins}
    },
    {
      name: 'AdminManagerUser',
      path: '/DPEBB/Administrator/ManageUsers',
      components: { default: AdminManagerUser}
    },
    {
      name: 'AdminManagerRolePer',
      path: '/DPEBB/Administrator/ManageRolePermissions',
      components: { default: AdminManagerRolePer}
    },
    {
      name: 'AdminUserManageUserRoles',
      path: '/DPEBB/Administrator/ManageUserRoles',
      components: {default:AdminUserManageUserRoles}
    },
  
    //Assessor
    {
      name: 'AssessorViewServiceCode',
      path:  '/DPEBB/Assessor/ViewServiceCode',
        components:{default:AssessorViewServiceCode}
    },
    {
      name: 'AssessorViewServiceType',
      path:  '/DPEBB/Assessor/ViewServiceType',
        components:{default:AssessorViewServiceType}
    },
    {
      name:'AssessorViewTaxStandard',
      path: '/DPEBB/Assessor/ViewTax',
      components:{default: AssessorViewTaxStandard}
    },
    {
      name:'AssessorViewProviders',
      path:'/DPEBB/Assessor/ViewProviders',
      components:{default:AssessorViewProviders}
    },
    {
      name:'AssessorViewClinics',
      path: '/DPEBB/Assessor/ViewClinics',
      components:{default: AssessorViewClinics}
    },
    //LeadAssessor
    {
      name: 'LeadAssessorViewServiceCode',
      path:  '/DPEBB/LeadAssessor/ViewServiceCode',
        components:{default:LeadAssessorViewServiceCode}
    },
    {
      name: 'LeadAssessorViewServiceType',
      path:  '/DPEBB/LeadAssessor/ViewServiceType',
        components:{default:LeadAssessorViewServiceType}
    },
    {
      name:'LeadAssessorViewTaxStandard',
      path: '/DPEBB/LeadAssessor/ViewTax',
      components:{default: LeadAssessorViewTaxStandard}
    },
    {
      name:'LeadAssessorViewProviders',
      path:'/DPEBB/LeadAssessor/ViewProviders',
      components:{default:LeadAssessorViewProviders}
    },
    {
      name:'LeadAssessorViewClinics',
      path: '/DPEBB/LeadAssessor/ViewClinics',
      components:{default: LeadAssessorViewClinics}
    },
    //Policy
    {
      name: 'DPEBBPolicyViewServiceCode',
      path:  '/DPEBB/Policy/ViewServiceCode',
        components:{default:DPEBBPolicyViewServiceCode}
    },
    {
      name: 'DPEBBPolicyViewServiceType',
      path:  '/DPEBB/Policy/ViewServiceType',
        components:{default:DPEBBPolicyViewServiceType}
    },
    {
      name:'DPEBBPolicyViewTaxStandard',
      path: '/DPEBB/Policy/ViewTax',
      components:{default: DPEBBPolicyViewTaxStandard}
    },
    {
      name:'DPEBBPolicyViewProviders',
      path:'/DPEBB/Policy/ViewProviders',
      components:{default:DPEBBPolicyViewProviders}
    },
    {
      name:'DPEBBPolicyViewClinics',
      path: '/DPEBB/Policy/ViewClinics',
      components:{default: DPEBBPolicyViewClinics}
    },
    //Finance
    { 
      name: 'FinanceDPEBBPaylist',
      path: '/DPEBB/Finance/ViewAllPaylist',
      components: { default: FinanceDPEBBPaylist},
    },
    { 
      name: 'FinanceDPEBBManageClinic',
      path: '/DPEBB/Finance/ManageClinics',
      components: { default: FinanceDPEBBManageClinic},
    },
    //HelpDesk
    {
      name: 'HelpDeskManagePassword',
      path: '/DPEBB/HelpDesk/ManageUserPassword',
      components: { default: HelpDeskManagePassword},
    },
    {
      path: '*',
      name: 'all',
      component: Login
    }
  ]

});

// router.beforeEach(async (to,from,next) => {
//   console.log('to.path = ' + to.path)
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login'];
//   const authRequired = !publicPages.includes(to.path);
//   const auth = store.getters.IsAuth;
// console.log('auth req= = ' + authRequired)
// console.log('isauth = = ' + auth)
// //console.log(to.fullPath)
//    if (authRequired && !auth) {
//     console.log('auth required cant move')
//   //     //auth.returnUrl = to.fullPath;
//       // return 'home';
//        //next("http://localhost:8080/");
//        next({ name: "home" });
//        //store.dispatch('Logout');
//        //router.push({ name: 'home' });
//    }
//    else 
//    {
//     //return true;
//     next();
//    }
// });
